/** Which block types open a group and which belong inside one, keyed by `__typename`. */
type GroupConfig = Record<string, { groupTypename: string; isHeader?: boolean; isEntry?: boolean }>

/** A group under construction: an optional header block plus the entry blocks that follow it. */
type ItemGroup = { __typename?: string; header?: CmsData; items: CmsData[] }

/*
 * Yields `CmsData` rather than `ItemGroup | CmsData`: a group is rendered by the same matrix components
 * as the blocks it wraps, so consumers treat both alike and a union here would only get in their way.
 */
function* generateGroupedItems(config: GroupConfig, items: CmsData[]): Generator<CmsData> {
  let group: ItemGroup | null = null

  for (const item of items) {
    const { groupTypename, isHeader, isEntry } = config[item.__typename] || {}
    if (isHeader) {
      if (group) yield group
      group = { __typename: groupTypename, header: item, items: [] }
    } else if (isEntry) {
      if (group && group.__typename === groupTypename) {
        group.items.push(item)
      } else {
        if (group) yield group
        group = { __typename: groupTypename, items: [item] }
      }
    } else {
      if (group) {
        yield group
        group = null
      }
      yield item
    }
  }

  if (group) yield group
}

export function setupDynamicContentItems(items: CmsData[]) {
  const config = {
    overviewDynamicContent_sectionHeader_BlockType: { groupTypename: 'overview_section_entries_group', isHeader: true },
    overviewDynamicContent_entry_BlockType: { groupTypename: 'overview_section_entries_group', isEntry: true },
    dynamicContent_foldout_BlockType: { groupTypename: 'foldout_entries_group', isEntry: true },
  }

  return { groupedItems: Array.from(generateGroupedItems(config, items)) }
}

export function itemTypeIs(item: CmsData | null | undefined, mustBeType: string) {
  if (!item || item.__typename === undefined) {
    return false
  }
  return (
    String(item.__typename)
      .replace(/^(discoveryOverview|overlay)?[D|d]ynamicContent_/, '')
      .replace(/_BlockType$/, '') === mustBeType
  )
}
